module.exports = __webpack_public_path__ + "static/img/map_768.9ad7e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/map_768.png
// module id = x4dT
// module chunks = 0